import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'torchFlag'
})
export class TorchFlagPipe implements PipeTransform {

  transform(value: string, ...args: any[]): string {
    switch (value) {
      case 'U':
        return 'Unknown';
      case 'Y':
        return  'Yes';
      case null:
      case 'N':
        return  'No'
      case 'I':
        return 'Indeterminate'
    }
  }

}
